<template>
  <div class="feed">
    <div class="container">
      <Navbar />
      <FiltersPlayers />
      <Footer />
    </div>
    <Notification :parentList="list" :user="user"/>
  </div>
</template>

<script>

import User from '../parse/models/User'
import Navbar from '@/components/Navigation';
import FiltersPlayers from '@/components/FiltersPlayers';
import Footer from '@/components/FooterInside';
import Notification from '@/components/Notification';
import WishList from '../parse/models/WishList'

export default {
  name: 'feed',
  components: {
    Navbar,
    FiltersPlayers,
    Footer,
    Notification
  },
  data(){
    return{
      login: 1,
      user: {},
      list: [],
      infoUser: ''
    }
  },
  created(){

    if(localStorage.token){
      this.$parse.User.become(localStorage.token)

      .then((res) => {
        if (res.id == '') {
          this.$router.push('/')
        }
      })
      .catch((error) => {
        this.logOut()
      });

    } else {
      this.$router.push('/')
    }
  },
  beforeMount() {


   localStorage.login = this.login;
    
    const data = this.$parse.User.current()
    
    console.log(data)

    User.detail(data.id).then((user) => {
     
        this.user = user

        /*user.loadWish().then((wishList) => {
        this.list = wishList*/
    })
    
    WishList.getList().then((wishList) => {
      this.list = wishList
    })

    /* Funcionality
    localStorage.login = this.login;
    
    User.detail(localStorage.objectId).then((user) => {
      this.user = user

      user.loadWish().then((wishList) => {
        this.list = wishList
      })
    })

    WishList.getList().then((wishList) => {
      this.list = wishList
    })*/
  },
  methods: {
    logOut(){
      localStorage.objectId = ''
      localStorage.token = ''
      const user = this.$parse.User.logOut()
      if (user) {
        this.$router.push('/')
      }
    }
  }
}
</script>
